module.exports = __webpack_public_path__ + "static/img/hl-workbench.40d0ce0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/hl-workbench.svg
// module id = FB45
// module chunks = 27